import * as React from 'react'
import { inject, observer } from 'mobx-react'
import {
  DebugInfo,
  Options,
  TestingLogo,
  TestingModeHeader
} from './TopTestingNavigationStyle'
import { StoreProps } from '../../stores'

const InfoImg = require('src/assets/wizard/info_i.png')

interface State {
  sendNotifications: boolean
  syncWithZoho: boolean
  onConfigurator: boolean // means its on wizard screens if false
}
const version = process.env.REACT_APP_VERSION

@inject('wizardStore', 'confStore')
@observer
export class TopTestingNavigation extends React.Component<StoreProps, State> {
  constructor(props) {
    super(props)
    const { wizardStore } = this.props
    const testingModeEnabled = location.search.includes('testMode')
    const onConfigurator = location.href.includes('detailplanung')
    this.state = {
      syncWithZoho: false,
      sendNotifications: false,
      onConfigurator
    }

    if (testingModeEnabled) {
      wizardStore.options.testingModeEnabled = true
      wizardStore.options.syncWithZoho = false
      wizardStore.options.sendNotifications = false
    }
  }

  toggleZohoSync = () => {
    const { onConfigurator } = this.state
    if (onConfigurator) {
      const { confStore } = this.props
      confStore.setSyncWithZoho(!confStore.getSyncWithZoho)
      this.setState({ syncWithZoho: confStore.getSyncWithZoho })
    } else {
      const { wizardStore } = this.props
      wizardStore.options.syncWithZoho = !wizardStore.options.syncWithZoho
      this.setState({ syncWithZoho: wizardStore.options.syncWithZoho })
    }
  }

  toggleSendNotifications = () => {
    const { onConfigurator } = this.state
    if (onConfigurator) {
      const { confStore } = this.props
      confStore.setSendNotifications(!confStore.getSendNotification)
      this.setState({ sendNotifications: confStore.getSendNotification })
    } else {
      const { wizardStore } = this.props
      wizardStore.options.sendNotifications = !wizardStore.options
        .sendNotifications
      this.setState({
        sendNotifications: wizardStore.options.sendNotifications
      })
    }
  }

  resolveSyncWithZohoFromOffer = () => {
    const { confStore } = this.props
    return this.translateOnOff(confStore.getSyncWithZoho)
  }

  resolveSendNotificationsFromOffer = () => {
    const { confStore } = this.props
    return this.translateOnOff(confStore.getSendNotification)
  }

  translateOnOff = (booleanValue) => {
    return booleanValue ? 'On' : 'Off'
  }

  options = () => {
    const { syncWithZoho, sendNotifications, onConfigurator } = this.state
    return (
      <Options>
        <a onClick={this.toggleZohoSync}>
          <p>
            Zoho:{' '}
            <span>
              {onConfigurator
                ? this.resolveSyncWithZohoFromOffer()
                : this.translateOnOff(syncWithZoho)}{' '}
            </span>
          </p>
        </a>
        <a onClick={this.toggleSendNotifications}>
          <p>
            Emails:{' '}
            <span>
              {onConfigurator
                ? this.resolveSendNotificationsFromOffer()
                : this.translateOnOff(sendNotifications)}{' '}
            </span>
          </p>
        </a>
      </Options>
    )
  }

  loading = () => {
    return (
      <Options>
        <p>Loading ...</p>
      </Options>
    )
  }

  render() {
    const { confStore } = this.props
    const { onConfigurator } = this.state
    const testingModeEnabled = location.search.includes('testMode')
    return (
      <>
        {testingModeEnabled || confStore.isTestingOffer ? (
          <TestingModeHeader>
            <DebugInfo>
              <p>
                Version : <span>{version}</span>
              </p>
            </DebugInfo>
            {onConfigurator && !confStore.isAllLoaded
              ? this.loading()
              : this.options()}
            <TestingLogo>
              <p>Testing Mode</p>
              <img src={InfoImg} />
            </TestingLogo>
          </TestingModeHeader>
        ) : (
          ''
        )}
      </>
    )
  }
}

export default TopTestingNavigation



// WEBPACK FOOTER //
// ./src/components/layout/TopTestingNavigation.tsx